import React, { useState, useRef, useEffect } from "react";
import Icon from "../Icon";
import {
  Container,
  InputContainer,
  SearchButton,
  SearchInput,
  SearchUl,
} from "./styles";

const Search = ({ onChange, onBlur, onSearch, children }) => {
  const [inputValue, setInputValue] = useState(``);
  const inputRef = useRef();

  const handleInputChange = async (evt) => {
    setInputValue(evt.target.value);
    onChange?.(evt);
  };

  const handleOnReturnPress = (evt) => {
    if (evt.keyCode === 13 && inputValue.length !== 0) {
      onSearch?.();
    }

    return;
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Container>
      <InputContainer>
        <SearchInput
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          ref={inputRef}
          onBlur={onBlur}
          onKeyDown={handleOnReturnPress}
        />
        <SearchButton onClick={() => onSearch?.() || null}>
          <Icon type="Search" />
        </SearchButton>
      </InputContainer>
      <SearchUl>{children}</SearchUl>
    </Container>
  );
};

export default Search;
